import { SMR_REPORT_FIELD_VALUE_CHANGE, SMR_REPORT_LISTS, SMR_REPORT_SETTINGS, SMR_REPORT_TOKENS, EDIT_SMR_REPORT } from "../actions/smrReportsAction";
import { isFulfilled, isPending, isRejected } from "./reducerUtils";

const reportIntitalValues = {
    reportName: "",
    reportType: null,
    deliveryTime: null,
    // frequency: null,
    weekday: null,
    monthday: null,
    startDate: null,
    endDate: null,
    // platforms: [],
    mailTo: "",
    smrrep: "",
};

const initialState = {
    editReport: null,
    reportTypeOptions: [],
    smrTokenLists: [],
    reportFieldValues: JSON.parse(JSON.stringify(reportIntitalValues)),
};

const smrReportsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SMR_REPORT_SETTINGS: {
            let reportType = action.payload?.filter((obj) => ["Daily Summary", "Weekly Summary", "Monthly Summary"].includes(obj.name)) || [];

            return { ...state, reportTypeOptions: reportType };
        }

        case SMR_REPORT_TOKENS: {
            return { ...state, smrTokenLists: action.payload };
        }

        case isPending(SMR_REPORT_LISTS):
            return { ...state, reportsList: [], reportListsLoading: true };

        case isFulfilled(SMR_REPORT_LISTS):
            return {
                ...state,
                reportsList: action.payload.reports.filter((obj) => obj.fields_setting_value?.reportTypeName).sort((a, b) => b.id - a.id),
                reportListsLoading: false,
            };

        case isRejected(SMR_REPORT_LISTS):
            return { ...state, reportsList: [], reportListsLoading: false };

        case SMR_REPORT_FIELD_VALUE_CHANGE:
            return { ...state, reportFieldValues: { ...state.reportFieldValues, [action.field]: action.value } };

        case EDIT_SMR_REPORT:
            return { ...state, editReport: action.payload || null };
        default:
            return state;
    }
};

export default smrReportsReducer;
